
























































































































import {
  computed,
  defineComponent,
  provide,
  onMounted,
  ref,
  watch,
  nextTick,
  getCurrentInstance
} from "@vue/composition-api";
import Layout from "@/components/Atoms/Layout/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccTag from "@/components/Atoms/OccTag/index.vue";
import FilterSection from "@/components/Molecules/FilterSection/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import OccSearchMultiSelectbox from "@/components/Atoms/OccSearchMultiSelectbox/index.vue";
import OccSearchSelectbox from "@/components/Atoms/OccSearchSelectbox/index.vue";
import Checkbox from "@/components/Atoms/Forms/Checkbox/index.vue";
import SearchTextField from "@/components/Atoms/Forms/SearchTextField/index.vue";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import ToggleContent from "@/components/Atoms/ToggleContent/index.vue";
import TableOfContents, {
  Content
} from "./Organisms/TableOfContents/index.vue";
import JobEventSidebar from "./Organisms/JobEventSidebar/index.vue";
import BasicInfoForm from "./Organisms/BasicInfoForm/index.vue";
import ScheduleForm from "./Organisms/ScheduleForm/index.vue";
import ResumeForm from "./Organisms/ResumeForm/index.vue";
import PublishingForm from "./Organisms/PublishingForm/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccSelectboxDate from "@/components/Atoms/OccSelectboxDate/index.vue";
import FieldErrorMessage from "@/components/Atoms/FieldErrorMessage/index.vue";
import TextArea from "@/components/Atoms/Forms/TextArea/index.vue";
import OccBreadcrumbs, {
  BreadcrumbRoute
} from "@/components/Atoms/OccBreadcrumbs/index.vue";
import MessageBar from "@/components/Atoms/MessageBar/index.vue";
import GuideBar from "@/components/Atoms/GuideBar/index.vue";
import ReadonlyModal from "@/components/Organisms/modals/ReadonlyModal/index.vue";
import ConfirmModal from "@/components/Organisms/modals/ConfirmModal/index.vue";
import { useRequest } from "@/helpers/hooks/useRequest";
import { getContractInformation, getCompanyLogo } from "@/api/index";
import { sendGaEvent } from "@/helpers/ga-helper";

import {
  TableOfContentType,
  formConfig,
  getEventDescriptionScrollKey,
  getScheduleScrollKey,
  initialJobEvent,
  QueryNames,
  tableOfContentConfig
} from "@/helpers/jobEvent";
import {
  useJobEvent,
  JOB_EVENT_STORE_KEY,
  JobEventError
} from "@/helpers/hooks/useJobEvent";
import { throttle } from "lodash";
import { useToggle } from "@/helpers/hooks/useToggle";
import { useGlobalState } from "@/helpers/hooks/useGlobalState";
import { useStore } from "@/store";
import { useRoute, useRouter } from "@/router";

export default defineComponent({
  components: {
    Layout,
    OccHeading,
    OccTag,
    TableOfContents,
    FilterSection,
    Button,
    OccSearchMultiSelectbox,
    OccSearchSelectbox,
    Checkbox,
    SearchTextField,
    LoadingView,
    ToggleContent,
    BasicInfoForm,
    ScheduleForm,
    ResumeForm,
    PublishingForm,
    OccButton,
    OccBreadcrumbs,
    MessageBar,
    GuideBar,
    OccSelectboxDate,
    FieldErrorMessage,
    TextArea,
    JobEventSidebar,
    ReadonlyModal,
    ConfirmModal
  },
  name: "JobEvent",
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const isNewJobEvent = route.name === "NewJobEvent";
    const [isShowReadonlyModal, toggleReadonlyModal] = useToggle(true);
    const [
      isShowWithdrawCompleteModal,
      toggleWithdrawCompleteModal
    ] = useToggle(false);

    const eventId = !isNewJobEvent ? Number(route.params.eventId) : undefined;

    provide(JOB_EVENT_STORE_KEY, useJobEvent({ eventId }));

    const {
      loading,
      editingJobEvent,
      isShowIWebSetting,
      jobEventErrors,
      jobEventWarns,
      getJobEventErrorMessage,
      disabledEdit,
      setEditingJobEvent,
      refreshEditingJobEvent,
      withdrawJobEvent
    } = useGlobalState(JOB_EVENT_STORE_KEY);

    const [{ data: contractsData, loading: contractLoading }] = useRequest(
      () => getContractInformation({ contract_types: ["job"] }),
      { immediate: true }
    );

    const breadcrumbRoute = computed<BreadcrumbRoute[]>(() => [
      {
        label: "イベント一覧",
        to: {
          name: "JobEvents"
        }
      },
      {
        label: editingJobEvent.value?.title || "",
        to: {
          name: "JobEvent"
        },
        disabled: true
      }
    ]);

    const isShowRejectReason = computed<boolean>(() => {
      if (!editingJobEvent.value) {
        return false;
      }
      return (
        editingJobEvent.value.approval_status === "rejected" &&
        !!editingJobEvent.value.reject_reason
      );
    });

    const rejectReasonLines = computed<number>(() => {
      if (!editingJobEvent.value || !editingJobEvent.value.reject_reason) {
        return 0;
      }

      const newLineCodeCount = editingJobEvent.value.reject_reason.match(
        /\r\n|\r|\n/g
      )?.length;
      return newLineCodeCount ? newLineCodeCount + 1 : 0;
    });

    const tableOfContents = computed<Content<TableOfContentType>[]>(() => {
      if (!editingJobEvent.value) {
        return [];
      }

      const addErrorCount = (
        content: Content<TableOfContentType>
      ): Content<TableOfContentType> => {
        const subContentErrors = content.subContents.filter(
          subContent => subContent?.invalid
        ).length;

        let otherErrors = 0;

        if (
          content.key === "scheduleForm" &&
          getJobEventErrorMessage("schedules")
        ) {
          otherErrors += 1;
        }

        return {
          ...content,
          errorCount: subContentErrors + otherErrors
        };
      };

      const contents: Content<TableOfContentType>[] = [
        {
          key: TableOfContentType["PublishingForm"],
          name: "公開設定",
          subContents: [
            {
              key: "category",
              name: "種別",
              invalid: !!getJobEventErrorMessage("category")
            },
            {
              key: "contract_id",
              name: "対象契約（卒年度）",
              invalid: !!getJobEventErrorMessage("contract_id")
            },
            {
              key: "reception_type",
              name: "受付方法",
              invalid: !!getJobEventErrorMessage("reception_type")
            },
            {
              key: "application_url",
              name: "申込先URL",
              invalid: !!getJobEventErrorMessage("application_url"),
              disabled: editingJobEvent.value.reception_type === "internal"
            },
            {
              key: "is_lottery",
              name: "ワンキャリアでの抽選",
              invalid: !!getJobEventErrorMessage("is_lottery")
            },
            {
              key: "i-web",
              name: "i-web連携",
              invalid:
                !!getJobEventErrorMessage("iweb_type") ||
                !!getJobEventErrorMessage("iweb_graduate_year") ||
                !!getJobEventErrorMessage("iweb_code"),
              hidden: !isShowIWebSetting.value
            }
          ]
        },
        {
          key: TableOfContentType["BasicInfoForm"],
          name: "基本情報",
          subContents: [
            {
              key: "title",
              name: formConfig["title"].label,
              invalid: !!getJobEventErrorMessage("title")
            },
            {
              name: formConfig["eye_catch_image"].label,
              key: "eye_catch_image",
              invalid: !!getJobEventErrorMessage("eye_catch_image")
            },
            {
              name: formConfig["attention_item"].label,
              key: "attention",
              hidden: editingJobEvent.value?.reception_type === "external"
            },
            ...[...(editingJobEvent.value.event_description_items || [])]
              .sort((a, b) => a.position - b.position)
              .filter(item => item.label !== formConfig["attention_item"].label)
              .map(item => {
                return {
                  key: getEventDescriptionScrollKey(item.id),
                  name: item.label,
                  invalid: !!(
                    item.id &&
                    (getJobEventErrorMessage(
                      "event_description_items/label",
                      item.id
                    ) ||
                      getJobEventErrorMessage(
                        "event_description_items/content",
                        item.id
                      ))
                  ),
                  hidden:
                    item.label === formConfig["attention_item"].label &&
                    editingJobEvent.value?.reception_type === "external"
                };
              })
          ]
        },
        {
          key: TableOfContentType["ScheduleForm"],
          name: "スケジュール",
          subContents: editingJobEvent.value.schedules.length
            ? editingJobEvent.value.schedules.map((schedule, index) => {
                return {
                  key: getScheduleScrollKey(schedule.id),
                  name: `スケジュール${index + 1}`,
                  invalid: !!(
                    schedule.id &&
                    (getJobEventErrorMessage("schedules/title", schedule.id) ||
                      getJobEventErrorMessage(
                        "schedules/time_limit_at",
                        schedule.id
                      ) ||
                      getJobEventErrorMessage(
                        "schedules/start_at",
                        schedule.id
                      ) ||
                      getJobEventErrorMessage(
                        "schedules/end_at",
                        schedule.id
                      ) ||
                      getJobEventErrorMessage(
                        "schedules/schedule_type",
                        schedule.id
                      ) ||
                      getJobEventErrorMessage("schedules/place", schedule.id) ||
                      getJobEventErrorMessage(
                        "schedules/limited_place",
                        schedule.id
                      ) ||
                      getJobEventErrorMessage(
                        "schedules/live_url",
                        schedule.id
                      ) ||
                      getJobEventErrorMessage(
                        "schedules/prefecture",
                        schedule.id
                      ) ||
                      getJobEventErrorMessage(
                        "schedules/admission_limit",
                        schedule.id
                      ) ||
                      getJobEventErrorMessage(
                        "schedules/entry_stopped",
                        schedule.id
                      ) ||
                      getJobEventErrorMessage(
                        "schedules/canceled",
                        schedule.id
                      ))
                  )
                };
              })
            : [{ key: "", name: "-" }]
        }
        // レジュメ機能への導線を閉じる
        // {
        //   key: TableOfContentType["ResumeForm"],
        //   name: "レジュメ",
        //   subContents: editingJobEvent.value.resume_questions.length
        //     ? [...editingJobEvent.value.resume_questions]
        //         .sort((a, b) => a.position - b.position)
        //         .map((resume, index) => {
        //           return {
        //             key: getResumeScrollKey(resume.id),
        //             name: `質問${index + 1}`,
        //             invalid: !!(
        //               resume.id &&
        //               (getJobEventErrorMessage(
        //                 "resume_questions/title",
        //                 resume.id
        //               ) ||
        //                 getJobEventErrorMessage(
        //                   "resume_questions/description",
        //                   resume.id
        //                 ) ||
        //                 getJobEventErrorMessage(
        //                   "resume_questions/min_length",
        //                   resume.id
        //                 ))
        //             )
        //           };
        //         })
        //     : [{ key: "", name: "-" }]
        // },
      ];

      return contents.map(addErrorCount);
    });

    const defaultContentKey =
      (route.query[QueryNames.TableOfContentType] as TableOfContentType) ||
      TableOfContentType["PublishingForm"];

    const selectedContentKey = ref<TableOfContentType>(defaultContentKey);

    const contentName = (contentKey: string) => {
      const content = tableOfContents.value.find(
        tableOfContent => tableOfContent.key === contentKey
      );
      if (!content) return "";

      return content.name;
    };

    const subContentName = (contentKey: string, subContentKey: string) => {
      const content = tableOfContents.value.find(
        tableOfContent => tableOfContent.key === contentKey
      );
      if (!content) return "";

      const subContent = content.subContents.find(
        subTableOfContent => subTableOfContent.key === subContentKey
      );
      if (!subContent) return "";

      return subContent.name;
    };

    const instance = getCurrentInstance();
    const onClickContent = (contentKey: TableOfContentType) => {
      selectedContentKey.value = contentKey;
      const routeName = isNewJobEvent ? "NewJobEvent" : "JobEvent";
      const routeParams = isNewJobEvent
        ? undefined
        : {
            eventId: String(eventId)
          };

      const query = {
        [QueryNames.TableOfContentType]: contentKey
      };

      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: `左サイドメニュー_${contentName(contentKey)}`
        });
      }

      nextTick(async () => {
        try {
          await router.push({
            name: routeName,
            params: routeParams,
            query
          });
        } catch (error) {
          return;
        }
      });
    };

    const onClickSubContent = ([contentKey, subContentKey]: [
      TableOfContentType,
      string
    ]) => {
      selectedContentKey.value = contentKey;

      const routeName = isNewJobEvent ? "NewJobEvent" : "JobEvent";
      const routeParams = isNewJobEvent
        ? undefined
        : {
            eventId: String(eventId)
          };

      const query = {
        [QueryNames.TableOfContentType]: contentKey
      };

      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: `左サイドメニュー_${contentName(
            contentKey
          )}_${subContentName(contentKey, subContentKey)}`
        });
      }

      // NOTE: 対象のフォームがレンダリングされてから hash を更新することで、
      // 正確な位置へ自動スクロールできる
      nextTick(async () => {
        try {
          await router.push({
            name: routeName,
            params: routeParams,
            query,
            hash: subContentKey && `#${subContentKey}`
          });
        } catch (error) {
          return;
        }
      });
    };

    const editAreaScrollTop = ref(0);
    const HEADER_HEIGHT = 48;

    const onScrollEditArea = throttle((event: Event) => {
      const targetElement = event.target;
      if (!targetElement || !(targetElement instanceof Element)) return;

      if (
        targetElement.scrollTop >= HEADER_HEIGHT &&
        editAreaScrollTop.value >= HEADER_HEIGHT
      ) {
        return;
      }

      editAreaScrollTop.value = Math.min(
        targetElement.scrollTop,
        HEADER_HEIGHT
      );
    }, 50);

    const headerTitleStyle = computed(() => {
      const progress = editAreaScrollTop.value / HEADER_HEIGHT;
      const fontSize = 18 - 6 * progress + "px";

      return {
        fontSize
      };
    });

    const getErrorDisplayText = (error: JobEventError) => {
      if (!editingJobEvent.value) {
        return;
      }

      const formType = formConfig[error.key].formType;
      const tableOfContentName =
        formType && tableOfContentConfig[formType].label;

      return tableOfContentName
        ? `${tableOfContentName} >> ${error.message}`
        : error.message;
    };

    const displayErrorMessages = computed(() => {
      if (!editingJobEvent.value) {
        return [];
      }

      const getErrorIndex = (errorKey: string) =>
        Object.keys(formConfig).findIndex(key => key === errorKey);

      jobEventErrors.value.sort((a, b) => {
        return getErrorIndex(a.key) - getErrorIndex(b.key);
      });

      return jobEventErrors.value.map(error => getErrorDisplayText(error));
    });

    const onClickWithdrawSubmission = async () => {
      if (!editingJobEvent.value) {
        return;
      }
      try {
        await withdrawJobEvent();
        toggleReadonlyModal();
        toggleWithdrawCompleteModal();
      } catch (error) {
        store.commit("common/updateAlertView", {
          isVisible: true,
          title: "予期せぬエラーが発生しました。",
          message: "再読実行してください"
        });
        throw error;
      }
    };

    const isShowCompanyLogoModal = ref(false);

    const onClickCompanyModalSetting = () => {
      router.push({
        name: "AccountsCompanyLogo"
      });
    };

    const closeCompanyLogoModal = () => {
      isShowCompanyLogoModal.value = false;
    };

    const onClickConfirm = async () => {
      clickedConfirm.value = true;
      await checkCompanyLogo();
    };

    const formsRef = ref<HTMLDivElement>();

    const scrollDestinationElement = (hash: string) => {
      if (!formsRef.value || hash === "") {
        return;
      }

      const destinationElement = formsRef.value.querySelector<HTMLDivElement>(
        hash
      );

      if (destinationElement) {
        destinationElement.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      }
    };

    const headerMessage = computed(() => {
      return is_waiting_for_publish()
        ? "公開予定・更新予定のため編集できません"
        : "掲載依頼中は編集できません";
    });

    const bodyMessage = computed(() => {
      return is_waiting_for_publish()
        ? "編集するには公開予約を取り消す必要があります"
        : "掲載依頼を取り消すと再度編集することができます。";
    });

    const withdrawSubmissionButtonLabel = computed(() => {
      return is_waiting_for_publish() ? "予約取り消し" : "掲載依頼を取り消し";
    });

    const is_waiting_for_publish = () => {
      return editingJobEvent.value?.approval_status === "waiting_for_publish";
    };

    const companyLogoUrl = ref<string>();
    const clickedConfirm = ref<boolean>(false);

    const checkCompanyLogo = async () => {
      const response = await getCompanyLogo();
      if (response && response.data && response.data.square_logo_url) {
        companyLogoUrl.value = response.data.square_logo_url;
      }
      if (response?.status === 400 || !response?.data?.square_logo_url) {
        isShowCompanyLogoModal.value = true;
      }
    };

    const companyLogoModalDesc = computed(() => {
      const text = `イベントを掲載するには企業ロゴが必要です。\n「設定 > 企業ロゴの設定」から設定してください。`;
      const warn = `\n※ 編集中の内容は下書き保存されています。`;
      return clickedConfirm.value ? text + warn : text;
    });

    const companyLogoModalCancelButton = computed(() => {
      return clickedConfirm.value ? "キャンセル" : "後で設定する";
    });

    onMounted(async () => {
      if (isNewJobEvent) {
        setEditingJobEvent(initialJobEvent);
      } else {
        refreshEditingJobEvent();
      }
      await checkCompanyLogo();
    });

    // TODO: vue-router3のhooksではrouteの変更を検知できないため、instance経由のrouteからアクセスする
    // vue-router4のhooksではrouteの変更を検知できるので、バージョンアップ時に書き換える。
    // https://router.vuejs.org/guide/advanced/composition-api.html#Accessing-the-Router-and-current-Route-inside-setup
    watch(
      [() => instance?.proxy.$route, loading], // TODO: vue-router4移行時に書き換える
      () => {
        if (!instance?.proxy.$route) return;
        const { hash, query } = instance.proxy.$route; // TODO: vue-router4移行時に書き換える
        const contentKey =
          (query[QueryNames.TableOfContentType] as TableOfContentType) ||
          (isNewJobEvent
            ? TableOfContentType["PublishingForm"]
            : TableOfContentType["BasicInfoForm"]);
        selectedContentKey.value = contentKey;
        nextTick(() => {
          scrollDestinationElement(hash);
        });
      },
      {
        immediate: true
      }
    );

    return {
      isNewJobEvent,
      eventId,
      loading,
      editingJobEvent,
      jobEventErrors,
      jobEventWarns,
      disabledEdit,
      setEditingJobEvent,
      getJobEventErrorMessage,
      tableOfContents,
      isShowRejectReason,
      rejectReasonLines,
      selectedContentKey,
      breadcrumbRoute,
      contractsData,
      contractLoading,
      isShowCompanyLogoModal,
      headerMessage,
      bodyMessage,
      withdrawSubmissionButtonLabel,

      onClickContent,
      onClickSubContent,
      displayErrorMessages,

      onScrollEditArea,
      headerTitleStyle,

      formsRef,

      isShowReadonlyModal,
      toggleReadonlyModal,
      onClickWithdrawSubmission,
      isShowWithdrawCompleteModal,
      toggleWithdrawCompleteModal,
      onClickCompanyModalSetting,
      closeCompanyLogoModal,
      onClickConfirm,
      companyLogoUrl,
      companyLogoModalDesc,
      companyLogoModalCancelButton
    };
  }
});
